<template>
  <div>
    <a
      v-for="link in links"
      :key="link.linkName"
      :href="link.url"
      style="display: block; text-decoration: underline;"
      target="_blank">
      {{ link.linkName }}
    </a>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import KeyValueTable from '@/components/structures/KeyValueTable'

export default {
  components: {
    KeyValueTable,
  },
  computed: {
    ...mapGetters(['selectedAgent']),
    links () {
      if (!this.selectedAgent) {
        return []
      }
      const { agent_links: agentLinks } = this.selectedAgent
      return agentLinks.map(({ link_name: linkName, url }) => ({ linkName, url }))
    },
  },
}
</script>
